import IInterventionThread from 'models/InterventionThread';

import { ReduxStore } from 'store/types';

function getAllThreadsList(state: ReduxStore): IInterventionThread[] {
  return state.intervention.getAllThreads.list;
}

export default getAllThreadsList;
